import { z } from 'zod';

import { schemaSlaceConversationMessage } from './SlaceConversationMessage';

// https://docs.slace.com/docs/stoplight-docs-core/712a2faa47456-conversation
export const schemaSlaceConversation = z.object({
    agent_requested: z.boolean(),
    agent_requested_type: z.enum(['static', 'dynamic']).optional(),
    // When true it means that human agent took over this conversation
    agent_taken: z.boolean(),
    blocked: z.boolean(),
    blocked_info: z.string().optional(),
    channel_id: z.string(),
    // this should usually be schemaSlaceCommunicationChannel but that would reference this schema recursively
    com_channel: z.unknown(),
    created_at: z.string(),
    custom_data: z.object({}).optional(),
    gateway_id: z.string(),
    id: z.string(),
    labels: z.array(z.string()).optional(),
    last_message: schemaSlaceConversationMessage.optional(),
    last_msg_at: z.string().optional(),
    last_received_msg_at: z.string().optional(),
    last_sent_msg_at: z.string().optional(),
    new_messages: z.number(),
    opt_out_type: z.enum(['stop', 'block', 'user']).optional(),
    opted_in: z.boolean(),
    opted_in_at: z.string().optional(),
    opted_out_at: z.string().optional(),
    read_at: z.string().optional(),
    update_at: z.string(),
});

export type SchemaSlaceConversation = z.infer<typeof schemaSlaceConversation>;
